<template>
  <div class="AuthAccount">
    <!-- title -->
    <div class="AuthAccount__title">
      <div>
        <img src="~@/assets/img/mypage/busan-logo-lg.svg" alt="" />
        <div class="mt10"><strong>원화 입금계좌 발급 및 등록</strong></div>
      </div>
    </div>
    <!-- //title -->
    <!-- body -->
    <div>
      <!-- 이용 동의 -->
      <div v-if="stage1" class="agree-wrap">
        <div class="title fs12"><strong>이용동의</strong></div>
        <div class="content mt32">
          <div class="sub">
            <div class="custom-checkbox">
              <input id="policyInfo" v-model="checked1" type="checkbox" />
              <label for="policyInfo">
                <img
                  width="14px"
                  :src="
                    require(`@/assets/img/mypage/${
                      checked1 ? 'confirm_checked' : 'confirm_check'
                    }.svg`)
                  "
                />
                <strong>
                  개인정보 수집 · 이용동의
                  <span class="keycolor">(필수)</span>
                </strong>
              </label>
            </div>
          </div>
          <div class="detail">
            <ul class="mt11">
              <li>* 수집목적: 실명확인 계좌번호 인증</li>
              <li>* 수집항목: 금융기관명, 계좌번호, 예금주명</li>
              <li>* 보유기간: 회원탈퇴 후 지체없이 삭제</li>
            </ul>
            <p class="mt20">
              개인정보 수집 및 이용 동의에 거부하실 수 있으며, 거부하실 경우
              서비스이용에 제한 됩니다.
            </p>
          </div>
        </div>
        <div class="content mt42">
          <div class="sub">
            <div class="custom-checkbox">
              <input id="otherPolicyInfo" v-model="checked2" type="checkbox" />
              <label for="otherPolicyInfo">
                <img
                  width="14px"
                  :src="
                    require(`@/assets/img/mypage/${
                      checked2 ? 'confirm_checked' : 'confirm_check'
                    }.svg`)
                  "
                />
                <strong>
                  개인정보 제3자 제공 동의
                  <span class="keycolor">(필수)</span>
                </strong>
              </label>
            </div>
          </div>
          <div class="detail">
            <ul class="mt11">
              <li>* 수집목적: 실명확인 계좌번호 인증</li>
              <li>* 수집항목: 금융기관명, 계좌번호, 예금주명</li>
              <li>* 보유기간: 회원탈퇴 후 지체없이 삭제</li>
            </ul>
            <p class="mt20">
              개인정보 제3자 제공 동의에 거부하실 수 있으며, 거부하실 경우
              실명확인 입출금계정 서비스가 제공되지 않습니다.
            </p>
          </div>
        </div>
        <div class="AuthAccount__button-wrap">
          <button class="back" @click="confirmBack">
            인증페이지로 돌아가기
          </button>
          <button
            :disabled="checked1 == false || checked2 == false"
            @click="toStage2"
          >
            동의
          </button>
        </div>
      </div>
      <!-- //이용 동의 -->
      <!-- 본인 입금계좌 정보 입력 -->
      <div v-else-if="stage2" class="agree-wrap">
        <div class="title fs12">실명확인 입금계좌 정보 입력</div>
        <!-- 은행명 -->
        <div class="input-wrap line mt15" flex>
          <div class="sub">
            <strong>은행명</strong>
          </div>
          <div
            v-if="vrBankLists.length >= 2"
            @click="bankListModal = true"
            class="vrbanks-wrap"
          >
            {{ vrBank == "" ? "은행을 선택하세요." : vrBank }}
          </div>
          <div v-else class="vrbanks-wrap">
            {{ vrBankName }}
          </div>
        </div>
        <!-- 계좌번호 -->
        <div class="input-wrap line mt15">
          <div class="sub">
            <strong>계좌번호</strong>
          </div>
          <div>
            <div class="account-address">
              <el-input
                v-model="accountAddress"
                placeholder="‘-’없이 숫자만 입력해 주세요."
                type="number"
                clearable
                class="account-address-input"
                :class="{ active: activeInput, wrong: wrongAddress }"
                @focus="focusInput"
              ></el-input>
              <!-- <input type="number" /> -->
              <button
                @click="checkAccountAddress"
                class="account-button active"
                :disabled="accountAddress.length < 8"
              >
                계좌조회
              </button>
            </div>
            <div v-if="wrongAddress" class="mt8 width-limit keycolor">
              * 계좌번호가 일치하지 않습니다.
            </div>
            <div v-else class="mt8 width-limit defaultcolor">
              <strong>은행 실명계좌의 계좌번호를 입력해 주세요.</strong>
            </div>
          </div>
        </div>
        <!-- 예금주명 -->
        <div class="input-wrap line mt17" flex>
          <div class="sub">
            <strong>예금주명</strong>
          </div>
          <div>
            <el-input
              placeholder="계좌 조회 시 자동으로 예금주 명이 노출 됩니다."
              v-model="accountOwnName"
              disabled
            ></el-input>
            <div class="mt8 width-limit">
              조회된 예금주 명이 플라이빗 가입 시 등록한 회원명과 동일한
              경우에만 원화 입출금 계좌 등록이 가능합니다.
            </div>
          </div>
        </div>
        <div class="AuthAccount__button-wrap">
          <button class="back" @click="confirmBack">
            인증페이지로 돌아가기
          </button>
          <button :disabled="disabledNextButton" @click="toStage3">
            다음
          </button>
        </div>
      </div>
      <!-- 실명확인 입금계좌 인증 -->
      <div v-else-if="stage3" class="agree-wrap">
        <div class="title fs12">실명확인 입금계좌 인증</div>
        <div class="noti-wrap mt30">
          <img src="~@/assets/img/mypage/noti-icon.svg" alt="" />
          {{ vrBank }} ({{ masking(accountAddress) }}) 계좌로 1원을 이체
          하였습니다.
        </div>
        <div class="detail-wrap mt20 text-center">
          <div>
            입금자명에 표시된
            <div class="fs20 fw500">
              플라이빗
              <span class="keycolor">
                인증번호 [숫자 3자리만]
              </span>
            </div>
            입력해 주세요.
          </div>
          <div class="example-box mt30">
            <div class="middle">
              <p class="fs16 fw500">예시 → [{{ userInfo.name }}] 플라이빗***</p>
            </div>
            <div class="bank-certifi-number fs16 fw500 mt21">
              <div class="name-box">[{{ userInfo.name }}] 플라이빗</div>
              <el-input
                v-model="sentNumber"
                placeholder="***"
                type="number"
                @input="checkNumberLength"
              ></el-input>
            </div>
          </div>
          <div class="address-number mt20">
            <div
              v-if="wrongSentNumber"
              class="wrong-number text-center keycolor mt13"
            >
              * 인증번호가 일치하지 않습니다.
            </div>
          </div>
        </div>
        <div class="AuthAccount__button-wrap">
          <button class="back" @click="confirmBack">
            인증페이지로 돌아가기
          </button>
          <button @click="toStage4">다음</button>
        </div>
      </div>
      <!-- //실명확인 입금계좌 인증 -->
      <!-- 가상계좌 최종 신청 -->
      <div v-else-if="stage4" class="agree-wrap stage4">
        <div class="text-wrap mt30 text-center fs-16">
          원화 입금을 위한
          {{ vrBankLists.length >= 2 ? vrBank : vrBankName }} 실명확인
          입금계좌를 발급합니다.
          <br />
          1인당 1개의 실명확인 입금 계좌만 가능합니다.
        </div>
        <div class="bottom-noti-box">
          <div class="title fs12">
            발급 안내
            <ul>
              <li class="fs10 mt20">
                은행점검 시간에는 실명확인 입출금 계좌번호 발급이 불가능합니다.(
                발급불가능 시간
                {{ vrBankLists.length >= 2 ? vrBank : vrBankName }}에 확인 필요)
              </li>
              <li class="fs10 mt10">
                ID가 여러 개 있는 회원이라도 1인당 1개의 실명확인 입출금
                계좌번호만 발급 가능합니다.
              </li>
              <li class="fs10 mt10">
                플라이빗 실명확인 입출금 계좌번호 발급이 완료되면
                {{ vrBankLists.length >= 2 ? vrBank : vrBankName }}의 계좌
                잔액을 플라이빗 실명확인 입출금 계좌로 이체하여 원화를 입금할 수
                있습니다.
              </li>
            </ul>
          </div>
        </div>
        <div class="AuthAccount__button-wrap">
          <button class="complte" @click="toStage5">
            {{ "실명확인 입금계좌 발급" }}
          </button>
        </div>
      </div>
      <!-- //가상계좌 최종 신청 -->
      <!-- 최종 완료 -->
      <div v-else-if="stage5" class="agree-wrap stage4">
        <div class="top-accounts-wrap">
          <!-- 가상계좌 은행 -->
          <div class="account-box">
            <div class="top-logo">
              <img src="~@/assets/img/mypage/busan-small-logo.svg" alt="" />
            </div>
            <div class="bottom-text busan-account mt25">
              <!-- 예금주명 -->
              <div class="user-name" flex>
                <p>{{ "예금주명" }}</p>
                <p class="ml10">{{ userInfo.name }}</p>
              </div>
              <!-- 은행계좌 -->
              <div class="bank-account mt8" flex>
                <p>{{ "은행계좌" }}</p>
                <p class="ml10">{{ masking(accountAddress) }}</p>
              </div>
            </div>
          </div>
          <!-- 가상계좌 -->
          <div class="account-box virtual-account">
            <div class="top-logo">
              <img src="~@/assets/img/mypage/flybit-small-logo.svg" alt="" />
            </div>
            <div class="bottom-text mt12">
              <!-- 예금주명 -->
              <div class="bank-name" flex>
                <p>{{ "은행명" }}</p>
                <p class="ml10">
                  {{ vrBankLists.length >= 2 ? vrBank : vrBankName }}
                </p>
              </div>
              <!-- 예금주명 -->
              <div class="user-name mt8" flex>
                <p>{{ "예금주명" }}</p>
                <p class="ml10">{{ userInfo.name }}</p>
              </div>
              <!-- 은행계좌 -->
              <div class="bank-account mt11" flex>
                <p class="text">{{ "은행계좌" }}</p>
                <p class="ml10 fs24 keycolor number">
                  {{
                    userInfo.accounts.vrAccount == null
                      ? "계좌가 없습니다."
                      : userInfo.accounts.vrAccount.accountNumber
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="deposit-link mt46">
            <router-link to="/balances/deposit/KRW">
              원화 입금하기
              <img src="~@/assets/img/mypage/arrow_icon.svg" alt="" />
            </router-link>
          </div>
        </div>
        <div class="bottom-noti-box">
          <div class="title fs12">
            발급 안내
            <ul>
              <li class="fs10 mt20">
                은행점검 시간에는 실명확인 입출금 계좌번호 발급이 불가능합니다.(
                발급불가능 시간
                {{ vrBankLists.length >= 2 ? vrBank : vrBankName }}에 확인 필요)
              </li>
              <li class="fs10 mt10">
                ID가 여러 개 있는 회원이라도 1인당 1개의 실명확인 입출금
                계좌번호만 발급 가능합니다.
              </li>
              <li class="fs10 mt10">
                플라이빗 실명확인 입출금 계좌번호 발급이 완료되면
                {{ vrBankLists.length >= 2 ? vrBank : vrBankName }}의 계좌
                잔액을 플라이빗 실명확인 입출금 계좌로 이체하여 원화를 입금할 수
                있습니다.
              </li>
            </ul>
          </div>
        </div>
        <div class="AuthAccount__button-wrap">
          <button class="complte" @click="close">
            {{ $t("confirm.done") }}
          </button>
        </div>
      </div>
      <!-- //최종 완료 -->
    </div>
    <!-- //body -->

    <!-- 가상계좌 리스트 팝업 -->
    <el-dialog
      :visible.sync="bankListModal"
      title="은행 선택"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group v-model="vrBank" @change="selectVRBank">
        <ul class="dropdown-list">
          <li v-for="(list, index) in vrBankLists" :key="index" class="mb10">
            <el-radio :label="list.name" />
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/common/Api";
import { mapGetters } from "vuex";
export default {
  name: "AuthAccount",
  data() {
    return {
      agreeModal: true,
      stage1: true, //계좌번호 입력 및 조회 화면
      stage2: false, //계좌번호 입력 및 조회 화면
      stage3: false, //1원 검증 화면
      stage4: false, //가상계좌 발급 안내 화면
      stage5: false, //가상계좌 발급 안내 화면
      checked1: false, //개인정보 활용 동의
      checked2: false, //제3자 수집 동의
      accountAddress: "", //계좌번호 value
      activeInput: false, //계좌번호 value 있을 때
      wrongAddress: false, //틀린 계좌번호일 때
      sentNumber: "", // 1원검증 입금자명 숫자 입력값
      wrongSentNumber: false, //인증번호
      accountOwnName: "", //예금주명
      disabledNextButton: true, //stage2의 다음 버튼 비활성화
      apiData: "", //계좌점유인증 api response data
      accountData: "", //계좌점유인증 확인 api respons data
      vrBank: "", // 가상계좌 은행 선택된 값
      vrBankLists: [], // 가상계좌 신청 가능 리스트
      bankList: [], // api에서 받은 가상계좌 은행 리스트
      bankListModal: false, //가상계좌 리스트 팝업
      selectedVRBank: false, // 선택한 가상계좌 은행 오브젝트
    };
  },
  computed: {
    ...mapGetters(["accounts", "userInfo", "isLogin"]),
    vrBankName() {
      return this.vrBankLists.length == 1 ? this.vrBankLists[0].name : null;
    },
  },
  methods: {
    confirmBack() {
      this.$router.push({
        name: "confirm",
      });
    },
    // 다음 버튼 : stage1 -> stage2(계좌 점유 인증)
    async toStage2() {
      this.stage1 = false;
      this.stage2 = true;
      const res = await Api.Setting.getBankList();
      this.bankList = res.data.result;
      const result = this.bankList.filter(
        // banklist 중 가상계좌 신청 가능 은행 오브젝트 골라내기
        (ele) => ele.vrBankYn === "Y"
      );
      this.vrBankLists = result; // 가상계좌 신청 가능 은행 오브젝트
    },
    // 다음 버튼 : stage2 -> stage3(1원 검증)
    async toStage3() {
      const params = {
        mchtCustId: String(this.userInfo.uuidx),
        custAcntNo: this.accountAddress,
        mchtCustNm: this.userInfo.name,
        bankCd:
          this.vrBankLists.length >= 2
            ? this.selectedVRBank.code
            : this.vrBankCode, //은행코드
      };
      try {
        this.apiData = await Api.User.checkRealUserAccount(params);
        this.stage2 = false;
        this.stage3 = true;
      } catch (error) {
        // console.log(error);
        return false;
      }
    },
    // 다음 버튼 : stage3 -> stage4(가상계좌 안내)
    async toStage4() {
      const params = {
        mchtCustId: String(this.userInfo.uuidx),
        authNo: this.sentNumber,
        trdNo: this.apiData.data.result.trdNo,
        mchtTrdNo: this.apiData.data.result.mchtTrdNo,
        custAcntNo: this.accountAddress,
        bankCd:
          this.vrBankLists.length >= 2
            ? this.selectedVRBank.code
            : this.vrBankCode, //은행코드
        orgTrdDt: this.apiData.data.result.orgTrdDt,
      };
      try {
        this.accountData = await Api.User.verifyAcntOccpCheck(params);
        this.stage3 = false;
        this.stage4 = true;
      } catch (error) {
        // console.log(error)
        this.wrongSentNumber = true;
      }
    },
    // 최종 가상계좌 발급 안내 팝업
    async toStage5() {
      const params = {
        vrBankCode:
          this.vrBankLists.length >= 2
            ? this.selectedVRBank.code
            : this.vrBankCode,
        custAcntNo: this.accountAddress,
        bankCode:
          this.vrBankLists.length >= 2
            ? this.selectedVRBank.code
            : this.vrBankCode,
        trdNo: this.accountData.data.result.trdNo,
        mchtTrdNo: this.accountData.data.result.mchtTrdNo,
        orgTrdDt: this.accountData.data.result.orgTrdDt,
        mchtCustId: String(this.userInfo.uuidx),
      };
      try {
        const res = await Api.User.addVirtualAccount(params);
        console.log(res);
        if (res.data.result == "계좌 발급을 성공했습니다.") {
          this.$store.dispatch("updateUserInfo");
          this.stage4 = false;
          this.stage5 = true;
        }
      } catch (error) {
        // console.log(error)
        return false;
      }
    },
    // stage2. 계좌 조회(예금주 성명 조회)
    async checkAccountAddress() {
      if (this.vrBankLists.length >= 2) {
        const selectedVRBank = _.find(this.vrBankLists, { name: this.vrBank });
        this.selectedVRBank = selectedVRBank;
      } else {
        this.vrBankCode = this.vrBankLists[0].code;
        this.vrBank = this.vrBankLists[0].name;
      }
      const params = {
        mchtCustId: String(this.userInfo.uuidx), //uuid
        custAcntNo: this.accountAddress, //계좌
        mchtCustNm: this.userInfo.name, //은행명
        bankCd:
          this.vrBankLists.length >= 2
            ? this.selectedVRBank.code
            : this.vrBankCode, //은행코드
      };
      try {
        const res = await Api.User.checkAccountHolder(params);
        if (res.data.result.mchtCustNm !== this.userInfo.name) {
          this.wrongAddress = true; //계좌번호 불일치
        } else {
          this.accountOwnName = res.data.result.mchtCustNm;
          this.disabledNextButton = false;
        }
      } catch (error) {
        console.error(error);
        this.wrongAddress = true; //계좌번호 불일치
      }
    },
    // 인풋 포커스인 시 value null
    focusInput() {
      this.accountAddress = "";
      this.wrongAddress = false;
    },
    // 마스킹
    masking(name) {
      const masked_name = name.slice(0, -4);
      const noneMasked_name = name.slice(name.length - 4);
      let masking = "";
      for (var i = 0; i < masked_name.length; i++) {
        masking = masking + "*";
      }
      return masking + noneMasked_name;
    },
    close() {
      this.$router.push({
        name: "confirm",
      });
    },
    // 1원 검증 인증번호 세자리 제한
    checkNumberLength() {
      if (this.sentNumber.length > 3) {
        this.sentNumber = this.sentNumber.slice(0, 3);
      }
    },
    selectVRBank() {
      this.bankListModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.AuthAccount {
  min-height: inherit;
  padding: 20px 20px 30px 20px;

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
  }

  &__button-wrap {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      width: 100%;
      height: 50px;
      flex-basis: calc(60% - 15px);
    }

    .back {
      background: #fff;
      color: #333;
      border: 1px solid #e6e6e6;
      font-size: 12px;
      flex-basis: 40%;
      word-break: keep-all;
    }

    .complte {
      flex: 1;
    }
  }

  .agree-wrap {
    font-size: 12px;

    li {
      list-style: none;
    }

    .title {
      font-weight: normal;
    }
    .input-wrap {
      width: auto;
      .vrbanks-wrap {
        width: 430px;
        height: 44px;
        padding: 14px 9px;
        font-size: 12px;
        border: 1px solid #d1d5da;
        background-color: #f4f4f4;
      }
      .sub {
        width: 64px;
        line-height: 44px;
        font-size: 10px;
        font-weight: normal;
      }
      button.account-button {
        flex-basis: 105px;
        height: 40px;
        margin-left: 8px;
        border-radius: 4px;
        background-color: #dadada;
        &.active {
          background-color: #eb3246;
        }
      }
    }
    .noti-wrap {
      position: relative;
      padding: 15px 15px 15px 30px;
      border-radius: 4px;
      border: solid 1px #dcdfe3;
      img {
        position: absolute;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);
      }
    }
    .example-box {
      position: relative;
      padding: 20px;
      border-radius: 2px;
      border: solid 1px #dcdfe3;
      background-color: #f7f8fa;
      p.hidden-number {
        padding: 5px 0 0 4px;
        font-size: 20px;
        line-height: 17px;
      }
    }
    .bottom-noti-box {
      width: 100%;
      padding: 20px;
      margin-top: 30px;
      border-radius: 4px;
      color: #333;
      background-color: #fafbfc;
      ul {
        li {
          position: relative;
          padding-left: 7px;
          color: #000;

          &:before {
            content: "";
            position: absolute;
            top: 6px;
            left: 0;
            width: 3px;
            height: 3px;
            border-radius: 10px;
            background-color: #333;
          }
          &.fs10 {
            font-size: 10px;
          }
        }
      }
    }
    .top-accounts-wrap {
      padding: 10px 10px 0 10px;

      .account-box {
        width: 100%;
        height: 142px;
        padding: 9px 20px 0 20px;
        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.05);
        border: solid 1px #dcdfe3;
        background-color: #fafbfc;

        &:before {
          content: "";
          position: absolute;
          top: 32px;
          left: 50%;
          transform: translateX(-50%);
          width: 250px;
          height: 1px;
          background-color: #dcdfe3;
        }
        .busan-account {
          color: #afafaf;
        }
      }
      .virtual-account {
        background-color: #fff;
        margin-top: 15px;

        .bottom-text {
          .bank-account {
            p.text {
              line-height: 24px;
            }
            p.number {
              font-weight: bold;
              line-height: 1;
            }
          }
        }
      }
      .deposit-link {
        position: relative;
        width: fit-content;
        margin: 0 auto;
        padding-right: 18px;
        color: #666;
        img {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        &:hover {
          text-decoration: underline;
          color: #333;
        }
      }
    }
  }
}

.fs12 {
  font-size: 12px;
}
.keycolor {
  color: #eb3246;
}
.defaultcolor {
  color: #333;
}
.account-address {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-input {
    flex: 1;
  }
}

.bank-certifi-number {
  display: flex;
  align-items: center;

  input {
    flex: 1;
  }

  .name-box {
    position: relative;
    flex-basis: 230px;
  }
}

.custom-checkbox {
  display: flex;
  align-items: center;

  input {
    position: absolute;
    opacity: 0;
  }

  label {
    display: flex;
    align-items: center;

    img {
      margin-right: 5px;
    }
  }
}
</style>
